const getDomainSelectors = () => {
  const modalEl = document.getElementById('external_link_modal');
  const excludedWarningSettings = modalEl
    ? (modalEl.dataset.allowedDomains || '').split(' ').filter(Boolean)
    : [];
  const excludedDomains = [];
  const domainSelectors = [];

  if (excludedWarningSettings.length > 0) {
    excludedWarningSettings.forEach((domain) => excludedDomains.push(domain));
  }

  excludedDomains.push(location.hostname);
  excludedDomains.push('domzihpgmwtth.cloudfront.net');
  excludedDomains.push('d2vy0o1uhm8qx1.cloudfront.net');
  excludedDomains.push('coorum-performance.test-dl-asobica.com');
  excludedDomains.push('coorum-dev.test-dl-asobica.com');
  excludedDomains.push('coorum-stg.test-dl-asobica.com');
  excludedDomains.push('community.dl-asobica.com');
  excludedDomains.push('i-coorum-dev.test-dl-asobica.com');
  excludedDomains.push('i-coorum-stg.test-dl-asobica.com');
  excludedDomains.push('i-community.dl-asobica.com');
  excludedDomains.push('stripe.com');
  excludedDomains.push('nitori-net.jp');

  for (const domain of excludedDomains) {
    domainSelectors.push(`[href*="${domain}"]`);
  }

  return domainSelectors;
};

export const initExternalLinkModal = () => {
  document.addEventListener('DOMContentLoaded', () => {
    bindExternalLinkModalEvent(document);
    $('#external_link, #external_link_btn').on('click', () => {
      $.modal.close();
    });
  });
};

export const bindExternalLinkModalEvent = (scopeEl) => {
  const domainSelectors = getDomainSelectors();
  const externalLinks = $(scopeEl)
    .find('a[href^=http]')
    .not(domainSelectors.join(','))
    .not('.js-allow-external-transition');

  externalLinks.each(function () {
    const self = $(this);
    const found = [
      '.block-text-comp',
      '.block-image-comp',
      '.block-rich-text-comp',
      '.c-anchor-banner',
      '.st-Nav_Item',
      '.p-card',
      '.p-category--timeline',
      '.st-GroupedNav_Item',
      '.st-NavFooter_Item',
      '.mypage-Article',
    ].find((className) => self.parents(className).length > 0);
    if (found !== undefined) return true;

    $(this).on('click', function (e) {
      e.preventDefault();
      const url = $(this).prop('href');
      const target = $(this).attr('target') || '_self';

      try {
        $('#external_link').prop('href', url);
        $('#external_link').text(url);
        $('#external_link_btn').prop('href', url);
        $('#external_link_modal').modal();

        // モーダルが実際に表示されたか確認（jquery-modal は表示時に display:block を設定する）
        const modalEl = document.getElementById('external_link_modal');
        const isVisible =
          modalEl &&
          (modalEl.style.display === 'block' ||
            modalEl.classList.contains('current') ||
            window.getComputedStyle(modalEl).display !== 'none');

        if (!isVisible) {
          // モーダルが表示されなかった場合はフォールバックで直接遷移
          window.open(url, target);
        }
      } catch (err) {
        // モーダル表示に失敗した場合はフォールバックで直接遷移
        window.open(url, target);
      }
    });
  });
};
